module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: [{
        open: _vm.open
      },
      'ro-nav-parent' ]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-1c53a76a"}!/Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./scripts/ro-nav/RoNavParent.vue
// module id = 364
// module chunks = 1